import React, { PropsWithChildren, ReactElement } from 'react';
import theme from './NavigationContextMenu.module.scss';
import { TranslatableText } from '@/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { classnames } from '@/utils/html';

export interface ExternalNavigationContextMenuItemProps extends PropsWithChildren {
    icon?: IconProp;
    imageElement?: ReactElement;

    title: TranslatableText;
    subtitle?: TranslatableText;
    clickable?: boolean;
    disabled?: boolean;
}

type HeaderDropdownItemProps = ExternalNavigationContextMenuItemProps & {
    wrapper?: Wrapper;
};

type Wrapper<T extends { className: string; disabled: boolean; tabIndex?: number } = any> = ReactElement<T>;

const NavigationContextMenuItem: React.FC<HeaderDropdownItemProps> = ({
    wrapper,
    imageElement,
    icon,
    title,
    subtitle,
    clickable = false,
    disabled = false,
}) => {
    return React.cloneElement(
        wrapper ?? <div />,
        { className: classnames(theme.item, { [theme.clickable]: clickable, [theme.disabled]: disabled }), disabled },
        <>
            <div className={theme.iconWrapper}>
                {icon && <FontAwesomeIcon icon={icon} />}
                {imageElement && imageElement}
            </div>
            <div className={theme.text}>
                {title}
                <small>{subtitle}</small>
            </div>
        </>
    );

    // return (
    //     <div className={theme.item} {...rest}>
    //         {imageElement && imageElement}
    //         {icon && <FontAwesomeIcon icon={icon} />}
    //         {title}
    //         <small>{subtitle}</small>
    //     </div>
    // );
};

export default NavigationContextMenuItem;
